import config from '../../../config';

import { FC } from 'react';
import dayjs from 'dayjs';
// i18next
import { useTranslation } from 'react-i18next';
// Models
import IQuiz from 'models/Quiz';
// Component
import { IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
// Icons
import { FaEye, FaRegClock } from 'react-icons/fa';

type Props = {
  quiz: IQuiz;
}

const QuizzesListItem:FC<Props> = ({ quiz }) => {
  const { t } = useTranslation();

  const handlePreview = () => {
    window.open(`${config.quizURL}/quiz/${quiz.quizNameSlug}?u=${new Date().getTime()}&preview=true`);
  };

  return (
    <tr>
      <td className="text-left title">
        {quiz.quizName}
      </td>
      <td className="text-left title">
        {quiz.account.organization}
      </td>
      <td className="text-left text">
        <FaRegClock className="icon" size="16px" />
        {quiz.startsDate ? dayjs(Number(quiz.startsDate)).format('MMM DD YYYY') : '-'}
      </td>
      <td className="text-left text">
        <FaRegClock className="icon" size="16px" />
        {quiz.endsDate ? dayjs(Number(quiz.endsDate)).format('MMM DD YYYY') : '-'}
      </td>
      <td className="text-right actions">
        <Tooltip className="ml-1" title={t('pages.activeQuizzes.previewButton')}>
          <IconButton
            onClick={handlePreview}
          ><FaEye /></IconButton>
        </Tooltip>
      </td>
    </tr>
  )
}

export default QuizzesListItem;
